import TBIcon from '../compoment/Icon';
import './login.scss';
import { Input, Button, message } from 'antd';
import { getUserLoginInfo, getExtUserTokenNotSign } from '../utils/servers';
import { orgUsertree } from '../utils/dataProcessing';
import { useState } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import actions from '../utils/actions';
import { GetUrlParam } from '../utils';
//import ReactSimpleVerify from 'react-simple-verify'
import 'react-simple-verify/dist/react-simple-verify.css';

function Login(props) {
	const { saveLoginInfo, saveMenus, addUserOrgs, addUserInfo, addMenusHistory, saveSySMenus } = props;
	//const [phone, setPhone] = useState('')
	const [orgId, setOrgId] = useState('');
	const [appId, setAppId] = useState('');
	const [secretKey, setSecretKey] = useState('');
	// const [code, setCode] = useState('')
	// const [msgId, setMsgId] = useState('')
	const history = useHistory();

	// const [disabled, setdisabled] = useState(true)

	const orgTypeCode = GetUrlParam('code');
	const bgImg = {
		1002015: 'fws',
		1002010: 'yg',
		1002020: 'syd'
	};
	const TypeName = {
		1002015: '人力资源服务商',
		1002010: '用工企业',
		1002020: '运营商'
	};
	// const gotoLogin = () => {
	//   checkCodes().then(data => {
	//     if (data) {
	//       login({phone, code, msgId, orgTypeCode}).then(data => {
	//         if (data.code === '200') {
	//           saveLoginInfo(data.data)
	//           Cookies.set('token', data.data.accessToken)
	//           localStorage.setItem('loginInfo', JSON.stringify(data.data))
	//           actions.setGlobalState({ loginInfo: data.data }); //通知主应用并修改initstate
	//           getUserLoginInfo().then(data => {
	//             if (data.code === '200') {
	//               saveMenus(data.data.userRoleFuncList ? data.data.userRoleFuncList : [])
	//               addUserOrgs(data.data.userOrgs || [])
	//               addUserInfo(data.data.userInfo || {})
	//             }
	//           })
	//           history.push('/')
	//         } else {
	//           message.error(data.msg || '账号异常，请稍后重试')
	//         }
	//       })
	//     }
	//   })
	// }
	const gotoLogin = () => {
		getExtUserTokenNotSign({ orgId, appId, secretKey }).then((data) => {
			if (data.code === '200') {
				saveLoginInfo(data.data);
				Cookies.set('token', data.data.accessToken);
				localStorage.setItem('loginInfo', JSON.stringify(data.data));
				actions.setGlobalState({ loginInfo: data.data }); //通知主应用并修改initstate
				getUserLoginInfo().then((data) => {
					if (data.code === '200') {
						localStorage.setItem('menus', JSON.stringify(data.data.userRoleFuncList));
						saveMenus(data.data.userRoleFuncList ? data.data.userRoleFuncList : []);
						saveSySMenus(data.data.userRoleFuncList ? data.data.userRoleFuncList : []);
						addUserOrgs(orgUsertree(data.data.userOrgsInfoList) || []);
						addUserInfo(data.data.userInfo || {});
						addMenusHistory([]);
					}
				});
				history.push('/');
			} else {
				message.error(data.msg || '账号异常，请稍后重试');
			}
		});
	};
	// const changePhone = (event) => {
	//   setPhone(event.target.value)
	// }
	const changeOrgId = (event) => {
		setOrgId(event.target.value);
	};
	const changeAppId = (event) => {
		setAppId(event.target.value);
	};
	const changeSecretKey = (event) => {
		setSecretKey(event.target.value);
	};
	// const register = () => {
	// 	if (orgTypeCode === '1002015') {
	// 		window.location.href = `${process.env.REACT_APP_REGISTEREDAUDIT_URL}/registered-audit-manager/serviceProvideDetail`;
	// 	} else if (orgTypeCode === '1002010') {
	// 		window.location.href = `${process.env.REACT_APP_REGISTEREDAUDIT_URL}/registered-audit-manager/businessDetail`;
	// 	} else if (orgTypeCode === '1002020') {
	// 		window.location.href = `${process.env.REACT_APP_REGISTEREDAUDIT_URL}/registered-audit-manager/sourcesManagerDetail`;
	// 	} else {
	// 		message.error('无效的登陆入口！');
	// 	}
	// };

	return (
		<div className="Login">
			<div className={`login-wrap ${bgImg[orgTypeCode]}`}>
				<div className="login-left">
					<div className="login">
						<TBIcon type="tb-logo-y" />
						<p>蜂巢灵工</p>
						<span className="segmentation"></span>
						<span>{TypeName[orgTypeCode]}</span>
					</div>
					<div className="login-title">
						<h1>企业用工数字化平台</h1>
						<p>服务、创新、科技、未来</p>
					</div>
				</div>
				<div className="login-right">
					{/* <p className="login-right-title">验证码登录</p> */}
					<p className="login-right-title">用户登录</p>
					<div>
						{/* <div className="login-right-tel">
              <p>+86 |</p>
              <Input placeholder="请输入手机号" value={phone} onChange={changePhone}/>
            </div> */}
						<div>
							<Input placeholder="请输入ORGID" value={orgId} onChange={changeOrgId} />
						</div>
						<div>
							<Input className="login-input" placeholder="请输入APPID" value={appId} onChange={changeAppId} />
						</div>
						<div>
							<Input
								className="login-input"
								type="password"
								placeholder="请输入SECRETKEY"
								value={secretKey}
								onChange={changeSecretKey}
							/>
						</div>

						{/* <ReactSimpleVerify disabled ref={couterRef} successTips={successTips} width={300} height={40} successIcon={successIcon} movedColor={'#ED6D1F'} success={success}/>
            {showCodeBtn && <div className="login-right-Code">
              <Input placeholder="请输入验证码" value={code} onChange={changeCode}/>
              <Button type="primary" onClick={getCode}>{codeTip}</Button>
            </div>}
            <div style={{marginTop: '40px'}}>
              <Button className={code ? 'loginButton': 'loginButtonDisabled'} type="primary" onClick={gotoLogin}>登录</Button>
            </div> */}
						<Button className="loginButton" type="primary" onClick={gotoLogin}>
							登录
						</Button>
						<div className="register">
							{/* <span>没有账号？</span>
							<span className="registerButton" onClick={register}>
								立即注册
							</span> */}
						</div>
					</div>
					<span className="copyRight">版权所有 © 2021 福建桐邦信息科技有限公司 | 闽ICP备2021001372号-2</span>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	return {
		menusHistory: state.menusHistory
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		saveLoginInfo: (info) => dispatch({ type: 'ADD_LOGININFO', info }),
		saveMenus: (info) => dispatch({ type: 'ADD_MENUS', info }),
		addUserOrgs: (info) => dispatch({ type: 'ADD_USERORGS', info }),
		addUserInfo: (info) => dispatch({ type: 'ADD_USERINFO', info }),
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		saveSySMenus: (info) => dispatch({ type: 'ADD_SYSMENUS', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
